module.exports = __webpack_public_path__ + "img/messages.131cdacf.svg";